define.alias("shared/components/shared/profile-avatar", "preview-grid/components/shared/profile-avatar");